import React, { useState, useEffect } from 'react';

/**
 * Komponent pre vstupné pole dátumu s automatickým formátovaním
 */
const DateInput = ({ value, onChange, onBlur, placeholder, className, id, error }) => {
  const [inputValue, setInputValue] = useState(value || '');

  // Aktualizácia vnútorného stavu pri zmene hodnoty z vonka
  useEffect(() => {
    if (value !== inputValue) {
      setInputValue(value || '');
    }
  }, [value, inputValue]);

  // Funkcia na formátovanie dátumu vo formáte DD.MM.YYYY
  const formatDate = (input) => {
    
    // Odstránenie všetkých znakov okrem číslic a bodiek
    const cleaned = input.replace(/[^\d.]/g, '');
    
    // Rozdelenie vstupu na číslice a bodky
    const digits = cleaned.replace(/\./g, '');
    
    let formatted = '';
    
    // Postupne pridávať číslice a bodky podľa formátu DD.MM.YYYY
    for (let i = 0; i < digits.length && i < 8; i++) {
      if (i === 2 || i === 4) {
        formatted += '.';
      }
      formatted += digits[i];
    }
    
    
    // Ošetrenie prípadu, keď užívateľ zadá bodku na konci
    if (input.endsWith('.') && (
        formatted.length === 3 || // Po DD.
        formatted.length === 6    // Po DD.MM.
    )) {
      // Už máme bodku, netreba pridávať ďalšiu
    } else if (input.endsWith('.') && (
        formatted.length === 2 || // Pred DD.
        formatted.length === 5    // Pred DD.MM.
    )) {
      formatted += '.';
    }
    
    return formatted;
  };

  // Handler pre zmenu vstupu
  const handleChange = (e) => {
    const rawValue = e.target.value;
    const formattedValue = formatDate(rawValue);
    
    setInputValue(formattedValue);
    
    // Odoslanie zmeny do parent komponentu
    if (onChange) {
      const event = { ...e, target: { ...e.target, value: formattedValue } };
      onChange(event);
    }
  };

  return (
    <input
      id={id}
      type="text"
      className={className}
      placeholder={placeholder || 'DD.MM.YYYY'}
      value={inputValue}
      onChange={handleChange}
      onBlur={onBlur}
    />
  );
};

export default DateInput;
